import * as React from "react";
import { AWSRoleARNGuide } from "./configuration/aws";
import { Drawer } from "antd";
import { CloudaccountCreateAzureConfigurationSubscriptionId } from "./configuration/azureSubscriptionId";
import { CloudaccountCreateAzureConfigurationFunction } from "./configuration/azureFunction";
import { CloudaccountCreateGCPConfigurationProjectId } from "./configuration/gcpProjectId";
import { formSetValue, useCpFormValue } from "../../gvc/testNewForm/utils";
import { useCpFormContext } from "../../../components/form/useCpFormContext";

interface Props {}
export const Drawers: React.FC<Props> = () => {
  const { id } = useCpFormContext();
  const drawer = useCpFormValue("meta.drawer");

  if (!drawer) {
    return null;
  }

  if (drawer === "provider-aws-role-arn-guide") {
    return (
      <Drawer
        className="temporary-drawer"
        open={true}
        title={"How to get AWS Role ARN?"}
        onClose={() => formSetValue(id, "meta.drawer", "")}
        closable
        maskClosable={true}
        mask={true}
        width={900}
      >
        <AWSRoleARNGuide />
      </Drawer>
    );
  }

  if (drawer === "provider-azure-subscription-id") {
    return (
      <Drawer
        className="temporary-drawer"
        open={true}
        title={`How to get Azure Subscription ID?`}
        onClose={() => formSetValue(id, "meta.drawer", "")}
        closable
        maskClosable={true}
        mask={true}
        width={800}
      >
        <CloudaccountCreateAzureConfigurationSubscriptionId />
      </Drawer>
    );
  }

  if (drawer === "provider-azure-function") {
    return (
      <Drawer
        className="temporary-drawer"
        open={true}
        title={"How to create Azure Function?"}
        onClose={() => formSetValue(id, "meta.drawer", "")}
        closable
        maskClosable={true}
        mask={true}
        width={800}
      >
        <CloudaccountCreateAzureConfigurationFunction />
      </Drawer>
    );
  }

  if (drawer === "provider-gcp-project-id") {
    return (
      <Drawer
        className="temporary-drawer"
        open={true}
        title={"How to get GCP Project ID?"}
        onClose={() => formSetValue(id, "meta.drawer", "")}
        closable
        maskClosable={true}
        mask={true}
        width={400}
      >
        <CloudaccountCreateGCPConfigurationProjectId />
      </Drawer>
    );
  }

  return null;
};
